import { Grid, IconButton, Tooltip } from "@mui/material";
import styled from "@emotion/styled";
import move from "../content/icons/move2.svg";
import { IDraggableAlignmentResultSection } from "store/types";
import { useState } from "react";
import { SectionMoveMenu } from "./SectionMoveMenu";
import { DraggableLocation } from "@hello-pangea/dnd";
import { HiddenChip, HiddenChip2 } from "components/Layout";

interface IProps {
  state: any;
  section: IDraggableAlignmentResultSection;
  column1?: string;
  column2?: string;
  items?: number;
  sidebar: boolean;
  expanded: boolean;
  onMoveResourceViaMenu: (source: DraggableLocation, destination: DraggableLocation, draggableId: string[]) => any;
  onExcludeResourceViaMenu?: (source: DraggableLocation, draggableId: string[]) => any;
}

const SidebarTitle = styled.p`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  padding: 0px;
  margin: 0px;
`;

const Title = styled.p`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 25px;
  line-height: 25px;
  padding: 0px;
  margin: 0px;
  color: #414141;
`;

const Column = styled.p`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  padding: 0px;
  margin: 0px;
  color: #6c6c6c;
`;

const Items = styled.p`
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 13px;
  padding: 0px;
  margin: 0px;
`;

export const SectionHeader = ({
  state,
  section,
  column1,
  items,
  sidebar,
  expanded,
  onMoveResourceViaMenu,
  onExcludeResourceViaMenu,
}: IProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const onMoveMenuClicked = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMoveMenu = () => setAnchorEl(null);
  const onMoveAll = (section: IDraggableAlignmentResultSection, destination: DraggableLocation) => {
    const source = {
      droppableId: section.uid,
      index: 0,
    } as DraggableLocation;
    onMoveResourceViaMenu(source, destination, section.resourceIds);
  };
  const onExcludeAll = (_section: IDraggableAlignmentResultSection) => {
    const source = {
      droppableId: section.uid,
      index: 0,
    } as DraggableLocation;
    onExcludeResourceViaMenu && onExcludeResourceViaMenu(source, section.resourceIds);
  };

  const style = sidebar
    ? {
        backgroundColor: "#6C6C6C",
        color: "white",
        padding: "4px",
        borderRadius: "0px",
        display: "flex",
        justifyContent: "left",
        alignItems: "center",
      }
    : { display: "flex", justifyContent: "left", alignItems: "center" };
  if (sidebar) {
    return (
      <Grid container style={style}>
        <Grid item xs={8}>
          <SidebarTitle>
            {section.name} {!section.visible && <HiddenChip2 label="Hidden" />}
          </SidebarTitle>
        </Grid>
        <Grid item xs={3} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
          <Items>{items} items</Items>
        </Grid>
        <Grid item xs={1} style={{ display: "flex", justifyContent: "right", alignItems: "center" }}>
          <Tooltip title="Move all" placement="top">
            <IconButton
              aria-owns={anchorEl ? "moveall-menu" : undefined}
              aria-haspopup="true"
              onClick={onMoveMenuClicked}
            >
              <img src={move} alt="move" />
            </IconButton>
          </Tooltip>
        </Grid>
        <SectionMoveMenu
          state={state}
          anchor={anchorEl}
          onClose={handleCloseMoveMenu}
          onMove={onMoveAll}
          onExclude={onExcludeResourceViaMenu ? onExcludeAll : undefined}
          section={section}
        />
      </Grid>
    );
  } else {
    return (
      <Grid container style={style}>
        <Grid item xs={8}>
          <Title>
            {section.name} {!section.visible && <HiddenChip label="Hidden" />}
          </Title>
        </Grid>
        {expanded && (
          <>
            <Grid item xs={4}>
              <Column>{column1}</Column>
            </Grid>
          </>
        )}
      </Grid>
    );
  }
};
